import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh, BiBarChart } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import DateTimePicker from "react-datetime-picker";
import { Country, State, City } from "country-state-city";
import "../CSS/DateTimePicker.css";
import "../CSS/Calendar.css";
import "../CSS/Clock.css";
import { SalesLeadDb } from "./SaleLeadsRawDb";
import Swal from "sweetalert2";
import SalesLeadDashboard from "./SaleLeadsDashboard";
import { FaWhatsapp } from "react-icons/fa";

import {
  OverlayTrigger,
  InputGroup,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Tabs,
  Tab,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
  FloatingLabel,
  FormControl,
} from "react-bootstrap";

/* Default lead sources used on frontend (no API) */
const DEFAULT_LEAD_SOURCES = [
  { id: 1, name: "Website / Online Ads" },
  { id: 2, name: "Walk-In / In-Store" },
  { id: 3, name: "Referral" },
  { id: 4, name: "Social Media" },
  { id: 5, name: "Events / Trade Shows" },
  { id: 6, name: "Others" },
];

export class SalesLeads extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      ShowLeadDbTabRefresh: true,
      ShowNewRequestTabRefresh: true,
      ShowFollowupTabRefresh: false,
      ShowClosedTabRefresh: false,
      refreshTab: false,
      addModalShow: false,
      users: [],
      searchTerm: "",
      counts: { NewRequest: 0, FollowUp: 0, Closed: 0 },
      showAnalytics: false,
      key: "NewRequest",
      isMobile: false,
    };

    this.salesLeadTableRef = React.createRef();
    this.searchTimeout = null;
  }

  componentDidMount() {
    this.GetUsers();
    this.checkMobile();
  }
  checkMobile = () => {
    const mq = window.matchMedia("(max-width: 767px)");
    this.setState({ isMobile: mq.matches });
  };

  openAnalytics = () => this.setState({ showAnalytics: true });
  closeAnalytics = () => this.setState({ showAnalytics: false });
  AddModalShow = () => this.setState({ addModalShow: true });
  addModalClose = () => {
    this.setState({ addModalShow: false });
    this.OnRefreshButtonClick();
  };

  updateTabCount = (stateKey, total) => {
    this.setState((prev) => ({
      counts: { ...prev.counts, [stateKey]: total ?? 0 },
    }));
  };

  GetUsers = () => {
    const config = {
      headers: { Authorization: `Bearer ${this.context.userData.bearertoken}` },
    };
    fetch(
      process.env.REACT_APP_API +
        "AdminUsers/GetStoreUserAccounts/" +
        this.context.storeId,
      config
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ users: data });
        }
      })
      .catch((error) => {
        alert("Session Timeout! Signout and Signin again!");
      });
  };

  refreshTab = () => {
    this.setState({ refreshTab: true }, () => {
      this.setState({ refreshTab: false });
    });
  };

  OnRefreshButtonClick = () => this.refreshTab();

  ShowSelectedTab = (k) => {
    this.setState({
      ShowLeadDbTabRefresh: false,
      ShowNewRequestTabRefresh: false,
      ShowFollowupTabRefresh: false,
      ShowClosedTabRefresh: false,
    });

    if (k == "LeadsRawDB") this.setState({ ShowLeadDbTabRefresh: true });
    if (k == "NewRequest") this.setState({ ShowNewRequestTabRefresh: true });
    if (k == "FollowUp") this.setState({ ShowFollowupTabRefresh: true });
    if (k == "Closed") this.setState({ ShowClosedTabRefresh: true });
  };

  onSearchChange = (value) => {
    this.setState({ searchTerm: value });
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.refreshTab();
      this.searchTimeout = null;
    }, 400);
  };

  onExportVisible = async () => {
    try {
      const state = this.state.key || "NewRequest";
      const storeId = this.context.storeId;
      const token = this.context.userData?.bearertoken;

      const url = `${process.env.REACT_APP_API}Leads/DownloadSalesLeadsCsv/${storeId}/${state}`;

      const resp = await fetch(url, {
        method: "GET",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (!resp.ok) {
        const txt = await resp.text();
        Swal.fire("Error", `Export failed: ${resp.status} ${txt}`, "error");
        return;
      }

      const blob = await resp.blob();
      const cd = resp.headers.get("content-disposition") || "";
      let filename = `salesleads_${state}.csv`;
      const m = cd.match(/filename="?([^"]+)"?/);
      if (m && m[1]) filename = m[1];

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(link.href);

      Swal.fire("Done", "CSV downloaded", "success");
    } catch (err) {
      console.error("Export failed", err);
      Swal.fire("Error", "Export failed. See console.", "error");
    }
  };

  onDeleteSelected = async () => {
    const ref = this.salesLeadTableRef && this.salesLeadTableRef.current;
    if (!ref || typeof ref.getSelectedIds !== "function") {
      if (ref && typeof ref.deleteSelected === "function") {
        return ref.deleteSelected();
      }
      Swal.fire(
        "Error",
        "Cannot access selected rows. Try refreshing.",
        "error"
      );
      return;
    }

    const ids = ref.getSelectedIds();
    if (!ids || ids.length === 0) {
      Swal.fire("Info", "No rows selected", "info");
      return;
    }

    const token = this.context.userData?.bearertoken;
    const storeId = this.context.storeId;

    const confirm = await Swal.fire({
      title: `Delete ${ids.length} lead(s)?`,
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    });

    if (!confirm.isConfirmed) return;

    try {
      const resp = await fetch(
        `${process.env.REACT_APP_API}Leads/DeleteSalesLeadsBulk/${storeId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify(ids),
        }
      );

      if (!resp.ok) {
        const txt = await resp.text();
        Swal.fire("Error", `Delete failed: ${resp.status} ${txt}`, "error");
        return;
      }

      const data = await resp.json();
      Swal.fire(
        "Deleted",
        `${data.deleted || ids.length} lead(s) removed`,
        "success"
      );

      if (ref && typeof ref.refresh === "function") ref.refresh();
      else this.refreshTab();
    } catch (err) {
      console.error("Bulk delete failed", err);
      Swal.fire("Error", "Bulk delete failed. See console.", "error");
    }
  };

  render() {
    return (
      <>
        <div className="container-fluid p-0">
          {/* Top Navbar */}
          {this.state.isMobile ? (
            <>
              <Navbar className="shadow position-sticky fixed-top px-3 bg-white">
                <Nav>
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <h5 className="mb-0 text-center">
                      <b>Leads Management</b>
                    </h5>

                    <div className="d-flex gap-2 flex-wrap">
                      <Button
                        className="mainthemecolor"
                        onClick={() => this.setState({ addModalShow: true })}
                      >
                        + Add
                      </Button>
                      <Button
                        className="mainthemecolor"
                        onClick={() => this.OnRefreshButtonClick()}
                      >
                        <BiRefresh size="18" />
                      </Button>
                      <Button
                        variant="outline-primary"
                        onClick={this.openAnalytics}
                        title="Show Analytics Dashboard"
                      >
                        <BiBarChart size={18} />
                      </Button>
                      <Button
                        variant="outline-primary"
                        onClick={() => this.onExportVisible()}
                      >
                        Export CSV
                      </Button>
                    </div>
                    <InputGroup className="me-2">
                      <Form.Control
                        placeholder="Search by name / mobile / address..."
                        value={this.state.searchTerm}
                        onChange={(e) => this.onSearchChange(e.target.value)}
                      />
                    </InputGroup>
                  </div>
                </Nav>
              </Navbar>
            </>
          ) : (
            <>
              <Navbar className="shadow position-sticky fixed-top  px-3">
                <h3>
                  <b>Leads Management</b>
                </h3>

                <Navbar.Collapse className="justify-content-end mx-0 ">
                  <Nav>
                    <div className="d-flex align-items-center gap-2">
                      <InputGroup style={{ width: "320px" }}>
                        <Form.Control
                          placeholder="Search by name / mobile / address..."
                          value={this.state.searchTerm}
                          onChange={(e) => this.onSearchChange(e.target.value)}
                        />
                      </InputGroup>
                      <Button
                        className="mainthemecolor"
                        onClick={() => this.setState({ addModalShow: true })}
                      >
                        + Add
                      </Button>
                      <Button
                        className="mainthemecolor"
                        onClick={() => this.OnRefreshButtonClick()}
                      >
                        <BiRefresh size="20" /> Refresh
                      </Button>

                      {/* NEW Analytics Button */}
                      <Button
                        variant="outline-primary"
                        onClick={this.openAnalytics}
                        title="Show Analytics Dashboard"
                      >
                        <BiBarChart size={20}></BiBarChart>
                        Analytics
                      </Button>
                      <Button
                        variant="outline-primary"
                        onClick={() => this.onExportVisible()}
                      >
                        Export CSV
                      </Button>
                      <Button
                        variant="outline-danger"
                        onClick={() => this.onDeleteSelected()}
                      >
                        Delete Selected
                      </Button>
                    </div>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </>
          )}

          {/* Purpose text */}
          <div className="purposestyle p-2 mt-0">
            <b>Purpose:</b> Use this Module to capture all your Leads, Followup,
            and convert to Sale. "Old Leads DB" keeps older contact & leads.
          </div>

          {/* Tabs */}
          <div className="p-2">
            {this.state.refreshTab == false ? (
              <>
                <Tabs
                  id="controlled-tab-example"
                  activeKey={this.state.key}
                  onSelect={(k) => {
                    this.setState({ key: k });
                    this.ShowSelectedTab(k);
                  }}
                  className="mb-3"
                  fill
                >
                  <Tab
                    eventKey="NewRequest"
                    title={`1.New Leads (${this.state.counts.NewRequest || 0})`}
                  >
                    {this.state.ShowNewRequestTabRefresh && (
                      <SalesLeadTable
                        ref={this.salesLeadTableRef}
                        CurrentState="NewRequest"
                        users={this.state.users}
                        searchTerm={this.state.searchTerm}
                        onCountUpdate={this.updateTabCount}
                        leadSources={DEFAULT_LEAD_SOURCES}
                      />
                    )}
                  </Tab>

                  <Tab
                    eventKey="FollowUp"
                    title={`2.Follow up (${this.state.counts.FollowUp || 0})`}
                  >
                    {this.state.ShowFollowupTabRefresh && (
                      <SalesLeadTable
                        ref={this.salesLeadTableRef}
                        CurrentState="FollowUp"
                        users={this.state.users}
                        searchTerm={this.state.searchTerm}
                        onCountUpdate={this.updateTabCount}
                        leadSources={DEFAULT_LEAD_SOURCES}
                      />
                    )}
                  </Tab>

                  <Tab
                    eventKey="Closed"
                    title={`3.Closed (${this.state.counts.Closed || 0})`}
                  >
                    {this.state.ShowClosedTabRefresh && (
                      <SalesLeadTable
                        ref={this.salesLeadTableRef}
                        CurrentState="Closed"
                        users={this.state.users}
                        searchTerm={this.state.searchTerm}
                        onCountUpdate={this.updateTabCount}
                        leadSources={DEFAULT_LEAD_SOURCES}
                      />
                    )}
                  </Tab>

                  <Tab eventKey="LeadsRawDB" title={"Old Leads DB"}>
                    {this.state.ShowLeadDbTabRefresh && <SalesLeadDb />}
                  </Tab>
                </Tabs>
              </>
            ) : (
              <></>
            )}
          </div>

          {this.state.addModalShow && (
            <LeadAddOrEditModal
              show={this.state.addModalShow}
              Type="Add"
              onHide={this.addModalClose}
              users={this.state.users}
              leadSources={DEFAULT_LEAD_SOURCES}
              OnSaved={() => this.refreshTab()}
            />
          )}

          {this.state.showAnalytics && (
            <SalesLeadDashboard
              show={this.state.showAnalytics}
              onHide={this.closeAnalytics}
              storeId={this.context.storeId}
              token={this.context.userData?.bearertoken}
              refreshParent={this.OnRefreshButtonClick}
            />
          )}
        </div>
      </>
    );
  }
}

/*
  SalesLeadTable: keeps logic but renders responsively
  - Table for md+ using Bootstrap's responsive helpers
  - Cards for sm/xs for readable mobile layout
*/
class SalesLeadTable extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      salesleads: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      customerTypeFilter: "",
      statusFilter: "",
      selectedRow: -1,
      selectedLeadRow: "",
      firstLoad: false,
      selectedIds: new Set(),
      followupRange: "all",
      leadSources: props.leadSources || DEFAULT_LEAD_SOURCES,
      leadSourceFilter: "",
      isMobile: false,
    };

    this._isMounted = false;
  }

  checkMobile = () => {
    const mq = window.matchMedia("(max-width: 767px)");
    this.setState({ isMobile: mq.matches });
  };

  componentDidMount = () => {
    this._isMounted = true;
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    if (this.state.firstLoad == false) {
      this.state.firstLoad = true;
      this.GetSalesLeads();
    }
    window.scrollTo(0, 0);
  };

  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener("resize", this.checkMobile);
  };

  OnFollowupRangeChange = (e) => {
    this.setState({ followupRange: e.target.value });
  };

  isDateInRange = (dateStr, range) => {
    if (!dateStr) return false;
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return false;

    const today = new Date();
    const startOfDay = (dt) => {
      const x = new Date(dt);
      x.setHours(0, 0, 0, 0);
      return x;
    };
    const endOfDay = (dt) => {
      const x = new Date(dt);
      x.setHours(23, 59, 59, 999);
      return x;
    };

    if (range === "today") {
      const s = startOfDay(today);
      const e = endOfDay(today);
      return d >= s && d <= e;
    }

    if (range === "week") {
      const day = today.getDay();
      const diffToMonday = (day + 6) % 7;
      const monday = startOfDay(
        new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - diffToMonday
        )
      );
      const sunday = endOfDay(
        new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6)
      );
      return d >= monday && d <= sunday;
    }

    if (range === "month") {
      const first = startOfDay(
        new Date(today.getFullYear(), today.getMonth(), 1)
      );
      const last = endOfDay(
        new Date(today.getFullYear(), today.getMonth() + 1, 0)
      );
      return d >= first && d <= last;
    }

    return true;
  };

  getSelectedIds = () => Array.from(this.state.selectedIds || []);

  refresh = () => this.GetSalesLeads();

  deleteSelected = async () => {
    const ids = this.getSelectedIds();
    if (ids.length === 0) {
      Swal.fire("Info", "No rows selected", "info");
      return;
    }

    if (
      this.props.onDeleteSelected &&
      typeof this.props.onDeleteSelected === "function"
    ) {
      return this.props.onDeleteSelected(ids);
    }

    const confirm = await Swal.fire({
      title: `Delete ${ids.length} lead(s)?`,
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    });

    if (!confirm.isConfirmed) return;

    this.ShowLoadSpinner();
    try {
      for (const id of ids) {
        await fetch(process.env.REACT_APP_API + "Leads/DeleteSalesLead/" + id, {
          method: "DELETE",
        });
      }
      this.ShowMessagBox("Status", "Deleted selected leads. Refreshing...");
      this.GetSalesLeads();
    } catch (err) {
      console.error("deleteSelected failed", err);
      Swal.fire("Error", "Failed to delete selected leads", "error");
    } finally {
      this.HideLoadSpinner();
      this.setState({ selectedIds: new Set() });
    }
  };

  exportVisibleToCsv = () => {
    const leads = this.getFilteredLeads();
    if (!leads || leads.length === 0) {
      Swal.fire("Info", "No leads to export", "info");
      return;
    }

    const header = [
      "Id",
      "Created",
      "CustomerName",
      "MobileNo",
      "Address",
      "CustomerType",
      "Status",
      "LeadSource",
    ];

    const rows = leads.map((l) => {
      let createdStr = "-";
      try {
        if (l.created) {
          const d = new Date(l.created);
          if (!isNaN(d)) createdStr = this.context.GetInDateFormat(d);
        }
      } catch (e) {
        createdStr = "-";
      }

      const addressParts = [
        l.address || "",
        l.city || "",
        l.state || "",
        l.country || "",
      ]
        .filter(Boolean)
        .join(", ");

      const leadSourceId = (() => {
        const idVal = l.leadSourceId ?? l.LeadSourceId ?? "";
        return idVal === null || idVal === undefined ? "" : String(idVal);
      })();

      return [
        l.id || "",
        createdStr,
        l.customerName || "",
        l.mobileNo || "",
        addressParts,
        l.customerType != null ? l.customerType : "",
        l.status != null ? l.status : "",
        leadSourceId,
      ];
    });

    const csvContent = [header, ...rows]
      .map((r) =>
        r.map((c) => `"${String(c || "").replace(/"/g, '""')}"`).join(",")
      )
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `salesleads_${new Date()
        .toISOString()
        .slice(0, 19)
        .replace(/[:T]/g, "-")}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  getFilteredLeads = () => {
    const raw = Array.isArray(this.state.salesleads)
      ? this.state.salesleads
      : [];
    let filtered = raw.filter((f) => {
      if (
        this.state.customerTypeFilter &&
        String(f.customerType) !== String(this.state.customerTypeFilter)
      )
        return false;
      if (
        this.state.statusFilter &&
        String(f.status) !== String(this.state.statusFilter)
      )
        return false;
      return true;
    });

    if (this.state.leadSourceFilter) {
      filtered = filtered.filter((f) => {
        const idVal = f.leadSourceId || f.LeadSourceId || "";
        return String(idVal) === String(this.state.leadSourceFilter);
      });
    }

    const q = (this.props.searchTerm || "").trim().toLowerCase();
    if (q) {
      filtered = filtered.filter((f) => {
        const name = (f.customerName || "").toString().toLowerCase();
        const mobile = (f.mobileNo || "").toString().toLowerCase();
        const address = (
          (f.address || "") +
          " " +
          (f.city || "") +
          " " +
          (f.state || "") +
          " " +
          (f.country || "")
        ).toLowerCase();
        return name.includes(q) || mobile.includes(q) || address.includes(q);
      });
    }

    if (
      this.props.CurrentState === "FollowUp" &&
      this.state.followupRange &&
      this.state.followupRange !== "all"
    ) {
      const range = this.state.followupRange;
      filtered = filtered.filter((f) => {
        const dateVal =
          f.nextFollowUpDate ||
          f.NextFollowUpDate ||
          f.nextFollowupDate ||
          f.NextfollowUpDate ||
          f.NextFollowupDate;
        return this.isDateInRange(dateVal, range);
      });
    }

    filtered.sort((a, b) => (a.created > b.created ? 1 : -1));
    return filtered;
  };

  GetSalesLeads = () => {
    fetch(
      process.env.REACT_APP_API +
        "Leads/GetSalesLeads/" +
        this.context.storeId +
        "/" +
        this.props.CurrentState
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ salesleads: data }, () => {
            if (typeof this.props.onCountUpdate === "function") {
              try {
                this.props.onCountUpdate(
                  this.props.CurrentState,
                  (data || []).length
                );
              } catch (e) {
                console.warn("onCountUpdate callback failed", e);
              }
            }

            this.setState({ reload: false }, () =>
              this.setState({ reload: true })
            );
          });
        }
      })
      .catch((error) => console.error("There was an error!", error));
  };

  toggleSelect = (id) => {
    const s = new Set(this.state.selectedIds);
    if (s.has(id)) s.delete(id);
    else s.add(id);
    this.setState({ selectedIds: s });
  };

  OnCustomerFilterChanges = (e) => {
    const value = e && e.target ? e.target.value : e || "";
    this.setState({ customerTypeFilter: value, reload: false }, () =>
      this.setState({ reload: true })
    );
  };

  OnStatusFilterChanges = (e) => {
    const value = e && e.target ? e.target.value : e || "";
    this.setState({ statusFilter: value, reload: false }, () =>
      this.setState({ reload: true })
    );
  };

  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });
  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });
  OnSaved = () => this.GetSalesLeads();
  OnDeleted = () => this.GetSalesLeads();

  renderTable = (leads) => {
    return (
      <div className="table-responsive">
        <Table hover border striped className="px-0 bg-white">
          <thead>
            <tr className="text-start text-black bg-white border">
              <th style={{ width: "3%" }}>
                <Form.Check
                  type="checkbox"
                  checked={
                    leads.length > 0 &&
                    this.state.selectedIds.size === leads.length
                  }
                  onChange={(e) => {
                    const s = new Set(this.state.selectedIds);
                    if (e.target.checked) leads.forEach((l) => s.add(l.id));
                    else leads.forEach((l) => s.delete(l.id));
                    this.setState({ selectedIds: s });
                  }}
                />
              </th>
              <th style={{ width: "5%" }}></th>
              <th style={{ width: "10%" }}>Created</th>
              <th style={{ width: "10%" }}>Customer</th>
              <th className="d-none d-md-table-cell" style={{ width: "20%" }}>
                Address
              </th>
              <th style={{ width: "10%" }}>MobileNo</th>
              <th className="d-none d-md-table-cell" style={{ width: "10%" }}>
                Lead Source
              </th>
              <th className="d-none d-sm-table-cell" style={{ width: "10%" }}>
                CustomerType
              </th>
              <th className="d-none d-sm-table-cell" style={{ width: "10%" }}>
                Status
              </th>
              <th className="d-none d-md-table-cell" style={{ width: "10%" }}>
                NextFollowup
              </th>
              <th className="d-none d-md-table-cell" style={{ width: "10%" }}>
                AssignedTo
              </th>
              <th style={{ width: "10%" }} className="text-end">
                Options
              </th>
            </tr>
          </thead>
          <tbody className="text-primary border">
            {leads.map((lead, i) => (
              <tr
                key={lead.id}
                className="text-start align-middle text-secondary bg-white py-2"
                style={{ fontSize: "14px" }}
              >
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={this.state.selectedIds.has(lead.id)}
                    onChange={() => this.toggleSelect(lead.id)}
                  />
                </td>
                <EditLeadInline
                  index={i}
                  lead={lead}
                  OnDeleted={this.OnDeleted}
                  users={this.props.users}
                  leadSources={this.props.leadSources || this.state.leadSources}
                  OnSaved={() => this.GetSalesLeads()}
                />
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  };

  renderCards = (leads) => {
    return (
      <div className="row g-2">
        {leads.map((lead, i) => (
          <div key={lead.id} className="col-12">
            <div className="card shadow-sm">
              <div className="card-body p-2">
                <div className="row align-items-start gx-2">
                  {/* Column 1: main data (left, wide) */}
                  <div className="col-5 ">
                    <div className="fw-bold">{lead.customerName || "-"}</div>
                    <div className="small text-muted">
                      {lead.mobileNo || "-"}
                    </div>
                    <div className="small">
                      {[lead.address, lead.city, lead.state, lead.country]
                        .filter(Boolean)
                        .join(", ")}
                    </div>
                  </div>

                  {/* Column 2: date / small meta (center) */}
                  <div className="col-5  text-sm-center text-start mt-2 mt-sm-0">
                    <div className="small text-muted">
                      {this.context.GetInDateFormat(new Date(lead.created))}
                    </div>
                    <div className="small mt-1">
                      {(() => {
                        const idVal =
                          lead.leadSourceId ?? lead.LeadSourceId ?? null;
                        if (!idVal) return "";
                        const found = (
                          this.props.leadSources || this.state.leadSources
                        ).find((x) => String(x.id) === String(idVal));
                        return found ? found.name : String(idVal);
                      })()}
                    </div>
                  </div>

                  {/* Column 3: action buttons (right) */}
                  <div className="col-2  text-sm-end text-start mt-2 mt-sm-0">
                    <EditLeadControls
                      lead={lead}
                      users={this.props.users}
                      leadSources={
                        this.props.leadSources || this.state.leadSources
                      }
                      OnSaved={() => this.GetSalesLeads()}
                      OnDeleted={() => this.GetSalesLeads()}
                    />
                  </div>
                </div>

                {/* Row below: customer type / status (keeps full width) */}
                <div className="d-flex justify-content-between mt-2 small text-muted">
                  <div>
                    {lead.customerType == 1
                      ? "COLD"
                      : lead.customerType == 2
                      ? "WARM"
                      : lead.customerType == 3
                      ? "HOT"
                      : ""}
                  </div>
                  <div className="text-end">
                    {/* Next followup date (if any) */}
                    {(() => {
                      const val = lead?.nextFollowUpDate;
                      if (!val) return "";
                      const d = new Date(val);
                      if (isNaN(d.getTime())) return "";
                      return this.context.GetInDateFormat(d);
                    })()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  render() {
    const leads = this.getFilteredLeads();

    return (
      <>
        <div className="container-fluid p-0">
          <div className="p-2">
            <Row className="w-100 m-0 p-0">
              <Col sm={12} className="border-0 m-0 p-0">
                <div className="p-2 d-flex flex-column gap-2">
                  <div className="d-flex flex-wrap gap-2">
                    <InputGroup style={{ minWidth: 140 }}>
                      <InputGroup.Text id="customer-type-label">
                        Customer Type
                      </InputGroup.Text>
                      <Form.Select
                        value={this.state.customerTypeFilter}
                        onChange={(e) => this.OnCustomerFilterChanges(e)}
                      >
                        <option value=""></option>
                        <option value="1">Cold</option>
                        <option value="2">Warm</option>
                        <option value="3">HOT</option>
                      </Form.Select>
                    </InputGroup>

                    <InputGroup style={{ minWidth: 160 }}>
                      <InputGroup.Text>Lead Source</InputGroup.Text>
                      <Form.Select
                        value={this.state.leadSourceFilter}
                        onChange={(e) =>
                          this.setState(
                            { leadSourceFilter: e.target.value, reload: false },
                            () => this.setState({ reload: true })
                          )
                        }
                      >
                        <option value="">All</option>
                        {(
                          this.props.leadSources ||
                          this.state.leadSources ||
                          []
                        ).map((ls) => (
                          <option key={ls.id} value={ls.id}>
                            {ls.name}
                          </option>
                        ))}
                      </Form.Select>
                    </InputGroup>

                    {this.props.CurrentState === "FollowUp" ? (
                      <InputGroup style={{ minWidth: 140 }}>
                        <InputGroup.Text>Follow-up</InputGroup.Text>
                        <Form.Select
                          value={this.state.followupRange}
                          onChange={this.OnFollowupRangeChange}
                        >
                          <option value="all">All</option>
                          <option value="today">Today</option>
                          <option value="week">This Week</option>
                          <option value="month">This Month</option>
                        </Form.Select>
                      </InputGroup>
                    ) : null}

                    <div className="flex-grow-1" />
                  </div>

                  {/* Render Table on md+, Cards on small screens */}
                  {this.state.isMobile
                    ? this.renderCards(leads)
                    : this.renderTable(leads)}
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}
      </>
    );
  }
}

// Card-friendly edit/delete controls for mobile cards
class EditLeadControls extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      editModalShow: false,
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
    };
  }

  openEdit = () => this.setState({ editModalShow: true });
  closeEdit = () => this.setState({ editModalShow: false });

  ShowMessagBox = (title, message) => {
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  };
  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  OnDelete = async () => {
    const lead = this.props.lead || {};
    if (!lead.id) {
      this.ShowMessagBox(
        "Information",
        "This row can't be deleted. Refresh and try again."
      );
      return;
    }

    const confirmed = await Swal.fire({
      title: "Delete this lead?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
    });

    if (!confirmed.isConfirmed) return;

    this.ShowLoadSpinner();
    try {
      const resp = await fetch(
        process.env.REACT_APP_API + "Leads/DeleteSalesLead/" + lead.id,
        { method: "DELETE" }
      );
      if (!resp.ok) {
        const txt = await resp.text();
        this.HideLoadSpinner();
        Swal.fire("Error", `Delete failed: ${resp.status} ${txt}`, "error");
        return;
      }
      this.HideLoadSpinner();
      Swal.fire("Deleted", "Lead removed", "success");
      if (typeof this.props.OnDeleted === "function") this.props.OnDeleted();
    } catch (err) {
      this.HideLoadSpinner();
      console.error("OnDelete failed", err);
      Swal.fire("Error", "Delete failed. See console.", "error");
    }
  };

  render() {
    const lead = this.props.lead || {};
    const canDelete =
      this.context.UserRoles &&
      this.context.UserRoles.PRODUCTADMIN == this.context.userData?.roleId;

    return (
      <>
        {this.state.editModalShow && (
          <LeadAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.closeEdit}
            lead={lead}
            Type="Edit"
            users={this.props.users}
            leadSources={this.props.leadSources}
            OnSaved={() => {
              if (typeof this.props.OnSaved === "function")
                this.props.OnSaved();
              this.closeEdit();
            }}
          />
        )}

        <div className="d-inline-flex align-items-center gap-1">
          <Button
            size="sm"
            variant="warning"
            onClick={this.openEdit}
            title="Edit"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M12.146.854a.5.5 0 0 1 .708 0l2.292 2.292a.5.5 0 0 1 0 .708l-9.792 9.792a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232L12.146.854zM11.207 2L3 10.207V13h2.793L14 4.793 11.207 2z" />
            </svg>
          </Button>

          <Button
            size="sm"
            variant="danger"
            onClick={this.OnDelete}
            title="Delete"
            disabled={!canDelete}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5z" />
              <path
                fillRule="evenodd"
                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
              />
            </svg>
          </Button>
        </div>
      </>
    );
  }
}

export class EditLeadInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      lead: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      editModalShow: false,
    };
  }

  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });
  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  OnDelete = () => {
    if (this.state.lead.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API + "Leads/DeleteSalesLead/" + this.state.lead.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This Lead may be associated with few Products. First disassociate this lead from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        if (this.props.OnDeleted) this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  GetUserNameById = (id) => {
    if (!id) return "";
    const guid = String(id).toLowerCase();
    if (this.props.users && this.props.users.length > 0) {
      const found = this.props.users.find(
        (u) => u.id && String(u.id).toLowerCase() === guid
      );
      if (found) return found.emailId || "";
    }
    return id;
  };

  componentDidMount = () => this.setState({ lead: this.props.lead });
  OnEditButtonClick = () => this.setState({ editModalShow: true });
  editModalClose = () => this.setState({ editModalShow: false });

  sanitizePhoneNumber(phone) {
    if (!phone) return "";
    const digits = String(phone).replace(/\D/g, "");
    // remove any leading zeros
    return digits.replace(/^0+/, "");
  }

  // return string suitable for wa.me (prefix with country code when needed)
  getWhatsAppNumber(phone) {
    const digits = this.sanitizePhoneNumber(phone);
    if (!digits) return null;

    // If digits already look like they include country code (length > 10), return as-is
    if (digits.length > 10) return digits;

    // if 10 digits, prepend country code - use store countryCode if present, fallback to 91
    const cc = (this.context?.store?.countryCode || "91")
      .toString()
      .replace(/\D/g, "");
    return `${cc}${digits}`;
  }

  render() {
    const lead = this.state.lead || {};

    const leadSourceDisplay = (() => {
      const idVal = lead.leadSourceId ?? lead.LeadSourceId ?? null;
      if (idVal === null || idVal === undefined || idVal === "") return "";
      const sources = this.props.leadSources || [];
      const found = sources.find((x) => String(x.id) === String(idVal));
      return found ? found.name : String(idVal);
    })();

    const leadSourceNumericId = (() => {
      const idVal = lead.leadSourceId ?? lead.LeadSourceId ?? null;
      return idVal === null || idVal === undefined ? "" : String(idVal);
    })();

    return (
      <>
        {this.state.editModalShow && (
          <LeadAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            lead={this.state.lead}
            Type="Edit"
            users={this.props.users}
            leadSources={this.props.leadSources}
            OnSaved={this.props.OnSaved}
          />
        )}

        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}

        <td>{this.props.index + 1}</td>
        <td className="text-start">
          {this.context.GetInDateFormat(new Date(this.state.lead.created))}
        </td>
        <td className="text-start">{this.state.lead.customerName}</td>
        <td className="d-none d-md-table-cell">
          {this.state.lead.address}, {this.state.lead.state},{" "}
          {this.state.lead.country}
        </td>
        <td className="text-start" style={{ whiteSpace: "nowrap" }}>
          {this.state.lead?.mobileNo || "—"}

          {/* whatsapp link */}
          {(() => {
            const waNum = this.getWhatsAppNumber(this.state.lead?.mobileNo);
            if (!waNum) return null;
            const waUrl = `https://wa.me/${waNum}`;

            return (
              <OverlayTrigger overlay={<Tooltip>Open WhatsApp</Tooltip>}>
                <a
                  href={waUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ms-2"
                  style={{ textDecoration: "none" }}
                  title={`WhatsApp ${this.state.lead?.mobileNo}`}
                >
                  <FaWhatsapp
                    size={18}
                    style={{ color: "#25D366", verticalAlign: "middle" }}
                  />
                </a>
              </OverlayTrigger>
            );
          })()}
        </td>
        <td className="d-none d-md-table-cell" title={leadSourceNumericId}>
          {leadSourceDisplay}
        </td>
        <td className="d-none d-sm-table-cell">
          {this.state.lead.customerType == 1
            ? "COLD"
            : this.state.lead.customerType == 2
            ? "WARM"
            : this.state.lead.customerType == 3
            ? "HOT"
            : ""}
        </td>
        <td className="d-none d-sm-table-cell">
          {this.state.lead.status == 1
            ? "Open"
            : this.state.lead.status == 2
            ? "FollowingUp"
            : this.state.lead.status == 3
            ? "Closed"
            : this.state.lead.status == 4
            ? "Cancelled"
            : ""}
        </td>
        <td className="d-none d-md-table-cell">
          {(() => {
            const val = this.state.lead?.nextFollowUpDate;
            if (!val) return "";
            const d = new Date(val);
            if (isNaN(d.getTime())) return "";
            return this.context.GetInDateFormat(d);
          })()}
        </td>
        <td className="d-none d-md-table-cell">
          {this.GetUserNameById(this.state.lead.assignedTo)}
        </td>
        <td className="col-md-2 text-end align-middle">
          <div className="btn-group my-2">
            <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
              <Button
                className="rounded-circle"
                variant="warning"
                size="sm"
                onClick={(e) => this.OnEditButtonClick(e)}
              >
                <BsFillPencilFill size="18" />
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              overlay={
                <Tooltip>
                  Warning! This will delete this Brand Row and associated
                  Products as well.
                </Tooltip>
              }
            >
              <Button
                className="mx-1 rounded-circle"
                variant="danger"
                disabled={
                  this.context.UserRoles.PRODUCTADMIN ==
                  this.context.userData.roleId
                    ? false
                    : true
                }
                size="sm"
                onClick={(e) => {
                  if (
                    window.confirm(
                      "Warning! This action will delete this Brand Row and associated Products as well. Are you sure you want to Delete?"
                    )
                  ) {
                    this.OnDelete(e);
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                  <path
                    fillRule="evenodd"
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                  />
                </svg>
              </Button>
            </OverlayTrigger>
          </div>
        </td>
      </>
    );
  }
}

/*
  Notes for integration:
  - This file relies on Bootstrap CSS being loaded in your app (react-bootstrap + bootstrap). The responsive helpers (d-none d-md-table-cell) come from Bootstrap.
  - If you want more compact mobile cards, tweak the renderCards markup.
  - If some subcomponents (LeadAddOrEditModal, LoadSpinner, MessageBox, SalesLeadDb, SalesLeadDashboard) are missing, keep your originals in place.
*/

export class LeadAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      lead: {
        country: "",
        state: "",
        status: 1,
        customerType: 1,
        nextFollowUpDate: new Date(),
        leadSourceId: null,
        assignedTo: "", // normalize as string
      },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      // local fallback list if props.leadSources not supplied
      leadSources: DEFAULT_LEAD_SOURCES,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide && this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  // Save / Add
  AddOrUpdateLeadInDB = async () => {
    try {
      const mobile = (this.state.lead.mobileNo ?? "").toString().trim();
      const mobileDigitsOnly = mobile.replace(/\D/g, "");
      if (
        !mobileDigitsOnly ||
        mobileDigitsOnly.length < 10 ||
        mobileDigitsOnly.length > 15
      ) {
        Swal.fire(
          "Invalid Mobile",
          "Enter a valid customer mobile number (10-15 digits).",
          "warning"
        );
        return;
      }

      this.ShowLoadSpinner();

      const tmpLead = { ...(this.state.lead || {}) };

      // backend may expect PascalCase LeadSourceId
      if (tmpLead.leadSourceId !== undefined && tmpLead.leadSourceId !== null) {
        tmpLead.leadSourceId = tmpLead.leadSourceId;
      }

      // assignedTo: if blank string -> null
      if (tmpLead.assignedTo === "") tmpLead.assignedTo = null;

      if (this.props.Type !== "Edit") {
        tmpLead.storeId = this.context.storeId;
        delete tmpLead.id;
        delete tmpLead.Id;
      }

      let apiBase = process.env.REACT_APP_API || "/";
      if (!apiBase.endsWith("/")) apiBase += "/";
      const baseHasApi = /\/api\/?$/i.test(apiBase) || /\/api\//i.test(apiBase);
      const url = baseHasApi
        ? `${apiBase}Leads/AddOrUpdateSalesLead`
        : `${apiBase}api/Leads/AddOrUpdateSalesLead`;

      const headers = { "Content-Type": "application/json" };
      const token = this.context.userData?.bearertoken;
      if (token) headers["Authorization"] = `Bearer ${token}`;

      const resp = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(tmpLead),
      });

      if (resp.ok) {
        this.HideLoadSpinner();
        Swal.fire("Saved", "Lead saved successfully.", "success");
        this.props.onHide && this.props.onHide();
        if (this.props.OnSaved) this.props.OnSaved();
        return;
      }

      let errText = `${resp.status} ${resp.statusText}`;
      try {
        const ct = resp.headers.get("content-type") || "";
        if (ct.includes("application/json")) {
          const json = await resp.json();
          errText = json?.error ?? JSON.stringify(json);
        } else {
          const text = await resp.text();
          if (text) errText = text;
        }
      } catch (ex) {}

      this.HideLoadSpinner();
      if (resp.status === 401 || resp.status === 403) {
        Swal.fire(
          "Unauthorized",
          "You are not authorized. Please login again.",
          "error"
        );
      } else if (resp.status === 400) {
        Swal.fire("Validation Error", errText, "warning");
      } else {
        Swal.fire("Save failed", `Server returned ${errText}`, "error");
      }
    } catch (ex) {
      this.HideLoadSpinner();
      console.error("AddOrUpdateLeadInDB exception:", ex);
      Swal.fire(
        "Error",
        "An exception occurred. See console for details.",
        "error"
      );
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdateLeadInDB();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    const leadCopy = { ...(this.state.lead || {}) };

    switch (name.trim()) {
      case "customerName":
      case "address":
      case "emailId":
      case "landMark":
      case "city":
      case "state":
      case "country":
      case "description":
        leadCopy[name] = value;
        break;
      case "mobileNo":
        // keep as string
        leadCopy.mobileNo = value;
        break;
      case "status":
      case "customerType":
        leadCopy[name] = value === "" ? null : parseInt(value, 10);
        break;
      case "assignedTo":
        leadCopy.assignedTo = value;
        break;
      case "leadSourceId":
        leadCopy.leadSourceId = value === "" ? null : parseInt(value, 10);
        break;
      default:
        leadCopy[name] = value;
    }

    this.setState({ lead: leadCopy });
  };

  onNextFollowupChange = (date) => {
    const leadCopy = { ...(this.state.lead || {}) };
    leadCopy.nextFollowUpDate = date;
    this.setState({ lead: leadCopy });
  };

  componentDidMount() {
    if (this.props.Type === "Edit" && this.props.lead) {
      // map incoming lead to local state and normalize assignedTo to string
      const incoming = { ...(this.props.lead || {}) };
      // normalize LeadSource
      if (incoming.LeadSourceId && !incoming.leadSourceId)
        incoming.leadSourceId = incoming.LeadSourceId;
      // normalize assignedTo to string (in case backend gives GUID)
      if (incoming.assignedTo !== undefined && incoming.assignedTo !== null) {
        incoming.assignedTo = String(incoming.assignedTo);
      } else {
        incoming.assignedTo = "";
      }
      // ensure nextFollowUpDate is Date or null
      if (incoming.nextFollowUpDate) {
        const d = new Date(incoming.nextFollowUpDate);
        incoming.nextFollowUpDate = isNaN(d.getTime()) ? null : d;
      }
      this.setState({ lead: incoming });
    } else {
      // when adding, ensure we have leadSources props if provided
      if (this.props.leadSources && this.props.leadSources.length) {
        this.setState({ leadSources: this.props.leadSources });
      }
    }
  }

  render() {
    const { lead } = this.state;
    const users = Array.isArray(this.props.users) ? this.props.users : [];
    const leadSources =
      (this.props.leadSources && this.props.leadSources.length
        ? this.props.leadSources
        : this.state.leadSources) || DEFAULT_LEAD_SOURCES;

    return (
      <div className="container">
        <Modal
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="LeadModal"
        >
          {this.state.msgboxOpen && (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          )}

          {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}

          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type === "Edit" ? "Edit lead" : "Add lead"}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {/* Use responsive grid: fields stack on xs, 2-per-row on md, multi-column on lg */}
              <Row className="g-2" style={{ fontSize: "13px" }}>
                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="Customer Name *" className="w-100">
                    <Form.Control
                      type="text"
                      name="customerName"
                      maxLength="99"
                      value={lead.customerName || ""}
                      required
                      onChange={this.handleInputChange}
                    />
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="Mobile No *" className="w-100">
                    <Form.Control
                      type="text"
                      name="mobileNo"
                      maxLength={15}
                      required
                      value={lead.mobileNo || ""}
                      onChange={this.handleInputChange}
                    />
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="EmailId" className="w-100">
                    <Form.Control
                      type="email"
                      name="emailId"
                      value={lead.emailId || ""}
                      onChange={this.handleInputChange}
                    />
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={12} lg={8}>
                  <FloatingLabel label="Address" className="w-100">
                    <Form.Control
                      type="text"
                      name="address"
                      maxLength="200"
                      value={lead.address || ""}
                      onChange={this.handleInputChange}
                    />
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="LandMark" className="w-100">
                    <Form.Control
                      type="text"
                      name="landMark"
                      maxLength="99"
                      value={lead.landMark || ""}
                      onChange={this.handleInputChange}
                    />
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="City *" className="w-100">
                    <Form.Control
                      type="text"
                      name="city"
                      required
                      maxLength="99"
                      value={lead.city || ""}
                      onChange={this.handleInputChange}
                    />
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="Country *" className="w-100">
                    <Form.Select
                      value={lead.country || ""}
                      name="country"
                      required
                      onChange={this.handleInputChange}
                    >
                      <option value=""></option>
                      {Country.getAllCountries().map((country) => (
                        <option key={country.isoCode} value={country.isoCode}>
                          {country.name}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="State *" className="w-100">
                    <Form.Select
                      value={lead.state || ""}
                      name="state"
                      required
                      onChange={this.handleInputChange}
                    >
                      <option value=""></option>
                      {lead.country &&
                        State.getStatesOfCountry(lead.country).map((s) => (
                          <option key={s.isoCode} value={s.name}>
                            {s.name}
                          </option>
                        ))}
                    </Form.Select>
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="Lead Source" className="w-100">
                    <Form.Select
                      name="leadSourceId"
                      value={lead.leadSourceId ?? ""}
                      onChange={this.handleInputChange}
                    >
                      <option value="">-- Select --</option>
                      {leadSources.map((ls) => (
                        <option key={ls.id} value={ls.id}>
                          {ls.name}
                        </option>
                      ))}
                    </Form.Select>
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="Importance *" className="w-100">
                    <Form.Select
                      name="customerType"
                      required
                      value={lead.customerType ?? 1}
                      onChange={this.handleInputChange}
                    >
                      <option value="1">Cold</option>
                      <option value="2">Warm</option>
                      <option value="3">HOT</option>
                    </Form.Select>
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="Status *" className="w-100">
                    <Form.Select
                      name="status"
                      required
                      value={lead.status ?? 1}
                      onChange={this.handleInputChange}
                    >
                      <option value="1">Open</option>
                      <option value="2">Following-Up</option>
                      <option value="3">Closed</option>
                      <option value="4">Cancelled</option>
                    </Form.Select>
                  </FloatingLabel>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <Form.Group className="w-100">
                    <label className="form-label small mb-1">
                      Next Follow-up
                    </label>
                    <div>
                      <DateTimePicker
                        onChange={this.onNextFollowupChange}
                        value={lead.nextFollowUpDate || null}
                        format="dd-MMM-yy"
                        className="w-100"
                      />
                    </div>
                  </Form.Group>
                </Col>

                <Col xs={12} md={6} lg={4}>
                  <FloatingLabel label="AssignedTo *" className="w-100">
                    <Form.Select
                      name="assignedTo"
                      required
                      value={lead.assignedTo}
                      onChange={this.handleInputChange}
                    >
                      <option value="">-- Select --</option>
                      {users.map((d) => {
                        if (d.emailId === "productsupport") return null;
                        return (
                          <option key={d.id} value={d.id}>
                            {d.emailId}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </FloatingLabel>
                </Col>

                <Col xs={12}>
                  <Form.Group as={Row} className="mb-3 mt-3" controlId="">
                    <Col sm="12">
                      <label className="form-label small">
                        Requirement &amp; FollowUp Details (upto 5000 letters)
                      </label>
                      <Form.Control
                        as="textarea"
                        rows={8}
                        name="description"
                        maxLength="4999"
                        value={lead.description || ""}
                        onChange={this.handleInputChange}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
